import React, { Component } from "react";
import { connect } from "react-redux";
import { Tabs } from "antd";

import ActiveRefills from "./ActiveRefills";
import InactiveRefills from "./InactiveRefills";
import OnHoldRefills from "./OnHoldRefills";
import PendingRefills from "./PendingRefills";
import ConfirmedRefills from "./ConfirmedRefills";
import DateCalls from "./DateCalls";
import SearchTab from "./SearchTab";
import OpalPatientStatus from "./OpalPatientStatus";

import { UPDATE_ACTIVE_TAB } from "../../ActionTypes/ActionTypes";

const { TabPane } = Tabs;

class RefillStatusTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hospital:
        window.location.port !== process.env.REACT_APP_HOSPITAL_PORT &&
        window.location.hostname !== process.env.REACT_APP_HOSPITAL_URL,
    };
  }

  callback = (value) => {
    const { updateActiveTab } = this.props;
    updateActiveTab(value);
    window.location.reload();
  };

  render() {
    const { activeTab } = this.props;

    return (
      <div className="card-container">
        <Tabs defaultActiveKey={activeTab} type="card" onChange={this.callback}>
          {this.state.hospital && (
            <TabPane tab="Active" key="1">
              <ActiveRefills />
            </TabPane>
          )}
          {this.state.hospital && (
            <TabPane tab="On Hold" key="2">
              <OnHoldRefills />
            </TabPane>
          )}
          {this.state.hospital && (
            <TabPane tab="Inactive" key="3">
              <InactiveRefills />
            </TabPane>
          )}
          {this.state.hospital && (
            <TabPane tab={<p style={{ color: "#E74C3C" }}>Pending</p>} key="4">
              <PendingRefills />
            </TabPane>
          )}
          {this.state.hospital && (
            <TabPane tab="Confirmed" key="5">
              <ConfirmedRefills />
            </TabPane>
          )}
          {this.state.hospital && (
            <TabPane tab="Search" key="7">
              <SearchTab />
            </TabPane>
          )}
          {this.state.hospital && (
            <TabPane tab="Opal Patient Status" key="8">
              <OpalPatientStatus />
            </TabPane>
          )}
          <TabPane tab="Date Calls" key="6">
            <DateCalls />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeTab: state.RefillState.activeTab,
});

const mapDispatchToProps = (dispatch) => ({
  updateActiveTab: (data) =>
    dispatch({ type: UPDATE_ACTIVE_TAB, payload: { data } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(RefillStatusTab);



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/RefillStatusTab.js